import React from 'react'
import { connect } from 'react-redux'
import { doGetEmailTempletList } from '../../reducers/actions'
import EmailTempletDiv from './EmailTempletDiv'
class EmailTempletListDiv extends React.Component {
  state = {}
  componentDidMount = () => {
    this.handleInitEmailTemplet()
  }
  handleInitEmailTemplet = () => {
    const { onSave, onClose, dispatch } = this.props
    dispatch(doGetEmailTempletList({
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ initValues基本信息 })
        }
      }
    }))
  }
  handleAddEmailTemplet = (data) => {
    Tyan.pubForm.showDialog('邮件模板设置', props => <EmailTempletDiv {...props} id={-1} onSave={this.handleInitEmailTemplet} />)
    this.setState({})
  }

  handleEditEmailTemplet = (data) => {
    Tyan.pubForm.showDialog('邮件模板设置', props => <EmailTempletDiv {...props} id={data.id} onSave={this.handleInitEmailTemplet} />)
    this.setState({})
  }

  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  fieldset模板 = () => {
    return [{
      _grid: '', name: '模板', rowNumbers: true, minRows: 5,
      columns: [
        { _text: '名称', name: '邮件模板名称', minWidth: 300, flex: 1 },
        { _text: '参数', name: '邮件模板参数', minWidth: 300, flex: 1 },
      ],
      onDoubleTap: this.handleEditEmailTemplet,
    }]
  }

  render = () => {
    const { showBody: Body } = this.props

    return <Body data={this} maxWidth={1200}
      controls={
        [
          { _button: '添加', handler: this.handleAddEmailTemplet },
          { _button: '关闭', handler: this.handlerClose },
        ]}
      fieldsets={[
        { title: '', name: '基本信息', _fieldset: this.fieldset模板(), flex: 1 },
      ]}
    />
  }
}

export default connect()(EmailTempletListDiv)